export default "__VITE_ASSET__DeGm07WY__"